<template>
	<div
		:class="[panelStatusClassname, modClassname, isPanelDisabledClassname, isPanelOccupiedClassname]"
		class="expansion-panel"
		ref="panelRef"
	>
		<loading-el v-if="loading"></loading-el>
		<div
			class="expansion-header"
			:class="headerEditableClassname"
			@click="toggleNonEditablePanel"
		>
			<div v-if="iconType" class="expansion-header__icon">
				<i :class="iconClassname"></i>
			</div>
			<h3
				:contenteditable="editable"
				@change="templateNameEdit"
				@blur="templateNameEdit"
				@keypress.enter="templateNameEdit"
				class="expansion-header__title"
				ref="templateNameRef"
			>{{ templateTitle }}</h3>
			<div
				@click="toggleEditablePanel"
				v-if="!occupied"
				class="expansion-header__indicator"
			>
				<i class="fa fa-chevron-right"></i>
			</div>
			<div
				v-else
				:class="occupied.colorName"
				class="map-user"
			>{{ occupied.initials }}</div>
		</div>
		<div
			:class="contentClassname"
			class="expansion-content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import {computed, nextTick, ref} from 'vue';
import LoadingEl from "@/components/ui/loading/LoadingEl.vue";

export default {
	components: {LoadingEl},
	props: {
		title: {
			type: String
		},
		panelKey: {
			type: Number,
		},
		panelOpened: {
			type: Number
		},
		disabled: {
			type: Boolean,
			default: false
		},
		editable: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false,
		},
		iconType: {
			type: String,
			default: ''
		},
		settingsContentRef: {
			default: null
		},
		contentClassname: {
			type: String,
			default: ''
		},
		modClassname: {
			type: String
		},
		occupied: {
			type: Object,
			default: null
		}
	},
  setup(props, {emit}) {
  	const isPanelOpened = computed(() => props.panelKey === props.panelOpened);
  	const panelStatusClassname = computed(() => isPanelOpened.value ? "opened" : "");
  	const isPanelDisabledClassname = computed(() => props.disabled ? "disabled" : "");
		const isPanelOccupiedClassname = computed(() => props.occupied !== null ? "disabled" : "");
  	
  	const iconClassname = computed(() => props.iconType === 'node' ? 'fas fa-shapes' : 'fas fa-arrows-alt-h rotated--45-left');
  	
  	const templateTitle = computed(() => props.title);
  	const templateNameRef = ref(null);
  	
  	const panelRef = ref(null);
  	const settingsContentReference = ref(props.settingsContentRef);
	
		const headerEditableClassname = computed(() => props.editable ? '' : 'cursor-pointer')
	  function toggleEditablePanel(event){
			if(props.editable) togglePanel(event);
	  }
	  function toggleNonEditablePanel(event){
			if(!props.editable) togglePanel(event);
	  }
		
	  function togglePanel(event){
		  event.stopImmediatePropagation();
		  event.stopPropagation();
		  emit('update:panelOpened', isPanelOpened.value ? null : +props.panelKey);
		  if(!isPanelOpened.value && settingsContentReference.value){
			  nextTick(() => {
				  settingsContentReference.value.scrollTop = panelRef.value.offsetTop - 58;
			  })
		  }
	  }
		
		function templateNameEdit(event){
			const title = event.target.innerText.trim();
			templateNameRef.value.blur();
			
			if (!title) {
				event.target.innerText = props.title;
			} else {
				templateTitle.value = title;
				emit('update:title', title);
			}
		}
		
		return {
			panelRef,
			templateTitle,
			templateNameRef,
			panelStatusClassname,
			headerEditableClassname,
			toggleEditablePanel,
			toggleNonEditablePanel,
			templateNameEdit,
			isPanelDisabledClassname,
			isPanelOccupiedClassname,
			iconClassname
		}
  }
}
</script>

<style lang="scss">
@use "@/scss/ui/expansion-panel/expansion-variables" as *;
@use "@/scss/ui/expansion-panel/expansion-panel";
@use "@/scss/ui/expansion-panel/expansion-header";
@use "@/scss/ui/expansion-panel/expansion-content";
@use "@/scss/mods/bg";
</style>
